<script>
  export let iconClasses = 'fas fa-smile'
  export let iconColor = '#198700'
  export let additionalStyles = ''
  let styleString = "color: " + iconColor + ";" + additionalStyles

  let className
  export { className as class }
</script>

<div class="legend-item { className }">
  <i class="{ iconClasses }" style="{ styleString }"></i>
  <slot />
</div>

<style>
  .legend-item {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    flex-basis: 25%;
    flex-grow: 1;
    justify-content: center;
    text-align: center;
    
  }
  @media (max-width:695px) {
    .legend-item  {
      flex-basis: 50%;
    }
  }

  @media(max-width:767px){
    .legend-item  {
      margin: 0.5em 0;
    }
  }
  @media (max-width:358px) {
    .legend-item  {
      flex-basis: 100%;
    }
  }
  i {
    
  }
</style>